import moment from 'moment';
import { Moment } from 'moment';
import { EmployeeRoleEnum } from '../../enums/EmployeeRoleEnum';

/**
 * A class represents the summarized information about a particular employee.
 */
export class Employee {
  employeePositionId: EmployeePositionId;
  name: string;
  role: EmployeeRoleEnum;
  contractHours: number;
  availableFrom?: Moment;
  deletedFrom?: Moment;

  /**
   * @param employeePositionId the identifier of an employee and their position.
   * @param name the employee's name.
   * @param role the role assigned to this employee.
   * @param contractHours the number of contracted hours.
   * @param availableFrom the date when the employee's contract started.
   * @param deletedFrom the date when the employee's contract terminates.
   */
  constructor(
    employeePositionId: EmployeePositionId,
    name: string,
    role: EmployeeRoleEnum,
    contractHours: number,
    availableFrom?: string,
    deletedFrom?: string
  ) {
    this.employeePositionId = employeePositionId;
    this.name = name;
    this.role = role;
    this.contractHours = contractHours;
    this.availableFrom = availableFrom ? moment(availableFrom) : null;
    this.deletedFrom = deletedFrom ? moment(deletedFrom) : null;
  }

  hasManagerRole() {
    return this.role === EmployeeRoleEnum.GENERAL_MANAGER || this.role === EmployeeRoleEnum.ASSISTANT_MANAGER;
  }
}

export class EmployeePositionId {
  value: string;

  constructor(employeeId: string, positionId: string) {
    this.value = employeeId + '#' + positionId;
  }

  parseEmployeeId(): string {
    return this.value.split('#')[0];
  }

  parsePositionId(): string {
    return this.value.split('#')[1];
  }
}
